/**
 * HubPairingsComponent created by karora on 16/02/19.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Pairing } from '../types/pairing';

@Component({
  selector: 'hub-pairings',
  template: `<hub-sub-menu></hub-sub-menu>
<div>
  <ul title="Pairings" class="pairings">
    <li [style.background-color]="'#1e1e1e'" class="headers">
      <span style="width: 11em">Created</span>
      <span style="width: 7em">IP</span>
      <span style="width: 5em">Code</span>
      <span style="width: 4em">UserID</span>
      <span style="width: 6em">App Version</span>
      <span style="width: 6em">Manufacturer</span>
      <span style="width: 8em">Model</span>
      <span style="width: 5em">Platform</span>
      <span style="width: 3.5em">Version</span>
      <span style="width: 4em">Paired</span>
    </li>
    <ng-container *ngFor="let p of pairings">
      <li [style.background-color]="getColor(p.paired)">
        <span style="width: 11em"> {{p.created}} </span>
        <span style="width: 7em"> {{p.ip}} </span>
        <span style="width: 5em"> {{p.pairingcode}} </span>
        <span style="width: 4em; text-align: right"> {{p.userid}} </span>
        <span style="width: 6em; text-align: center"> {{p.appversion}} </span>
        <span style="width: 6em"> {{p.manufacturer}} </span>
        <span style="width: 8em"> {{p.model}} </span>
        <span style="width: 5em"> {{p.platform}} </span>
        <span style="width: 3.5em"> {{p.version}} </span>
        <span style="width: 4em">
          <span *ngIf="p.userid > 0" class="toggleField" (click)="togglePairing(p)">
            <ng-container *ngIf="!!p.paired; else notPaired">
              <mat-icon class="md-48" color="primary" aria-label="Disable pairing" >check_circle_outline</mat-icon>
            </ng-container>
            <ng-template #notPaired>
              <mat-icon class="md-48" color="warn" aria-label="Enable pairing">highlight_off</mat-icon>
            </ng-template>
          </span>
        </span>
      </li>
    </ng-container>
  </ul>
</div>`,
  styles: [
    `ul.pairings { margin: 0 0 2em 0; list-style-type: none; padding: 0; width: 100%; }`,
    `li { height: 2em; vertical-lign: middle; }`,
    `span { display: inline-block; border-radius: 0; border: none; padding: 0.3em 0.6em; }`,
    `.day { font-weight: bold; width: 6.5em; color: #d0d0d0; background-color: #1e1e1e;}`,
    `li.headers span { font-weight: bold; text-align: center; color: #d0d0d0; background-color: #1e1e1e;}`,
    `ul.pairings li { position: relative; left: 0; margin: .2em 0; padding: 0; height: inherit; background-color: #DDD; width: 100%;
    }`,
    `.mat-raised-button { line-height: 1.5em;} `,
  ],
  providers: [HubService],
})


export class HubPairingsComponent implements OnInit {
  hubID: number;
  pairings = <Pairing[]>[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err && err.status !== 401) {
      console.log('HubPairingsComponent Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.refresh();
  }

  refresh(): void {
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getPairings(+params['hubid']))
    ).subscribe(
      (pairings: Pairing[]) => { this.gotPairings(pairings), console.log(pairings) },
      err => HubPairingsComponent.handleRefreshError(err)
    );
  }

  gotPairings(pairings: Pairing[]) {
    this.pairings = pairings;
    console.log('Switched HUB: ' + this.hubID);
    console.log(JSON.stringify(pairings, null, 2));
  }

  getColor(paired: boolean): string {
    if (paired)
      return "#80f08e"
    else
      return "#e88080"
  }

  getButton(paired: boolean): string {
    if (paired)
      return "Revoke"
    else
      return "Unrevoke"
  }

  togglePairing(pairing: Pairing): void {
    this.hubService.togglePairing(pairing)
      .subscribe(
        res => this.refresh(),
        err => HubService.LogRefreshError(err),
      );
  }

}

